import React, {useState} from 'react'


export default function TextForm(props) {
    const handleUpClick = ()=>{
        // console.log("Uppercase was clicked: " +  text);
        let newText = text.toUpperCase();
        setText(newText)
        props.showAlert("Converted to uppercase!", "success");
    }

    const handleLoClick = ()=>{ 
        let newText = text.toLowerCase();
        setText(newText)
        props.showAlert("Converted to lowercase!", "success");
    }

    const handleClearClick = ()=>{ 
        let newText = '';
        setText(newText);
        props.showAlert("Text Cleared!", "success");
    }

    const handleOnChange = (event)=>{
        // console.log("On change");
        setText(event.target.value) 
    }

    // Credits: A
    const handleCopy = () => {
        console.log("I am copy");
        var text = document.getElementById("myBox");
        text.select();
        text.setSelectionRange(0, 9999);
        navigator.clipboard.writeText(text.value);
        props.showAlert("Copied to Clipboard!", "success");
    }

    // Credits: Coding Wala
    const handleExtraSpaces = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra spaces removed!", "success");
    }

    const [text, setText] = useState(''); 
    // text = "new text"; // Wrong way to change the state
    // setText("new text"); // Correct way to change the state
    return (
        <>
        <div className="container" style={{color: props.mode==='dark'?'white':'#042743'}}> 
            <h1>{props.heading}</h1>
            <div className="mb-3"> 
            <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'grey':'white', color: props.mode==='dark'?'white':'#042743'}} id="myBox" rows="8"></textarea>
            </div>
            <button className="btn btn-primary mx-1" onClick={handleUpClick}>Convert to Uppercase</button>
            <button className="btn btn-primary mx-1" onClick={handleLoClick}>Convert to Lowercase</button>
            <button className="btn btn-primary mx-1" onClick={handleClearClick}>Clear Text</button>
            <button className="btn btn-primary mx-1" onClick={handleCopy}>Copy Text</button>
            <button className="btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
        </div>
        <div className="container my-3" style={{color: props.mode==='dark'?'white':'#042743'}}>
            <h2>Your text summary</h2>
            <p>{text.split(" ").length} words and {text.length} characters</p>
            <p>{0.008 *  text.split(" ").length} Minutes read</p>
            <h2>Preview</h2>
            <p>{text.length>0?text:"Enter something in the textbox above to preview it here"}</p>
        </div>
        </>
    )
}







































































// import React, {useState} from 'react'


// export default function TextForm(props) {
//     const handleUpClick = ()=>{
//         // console.log("Uppercase was clicked: " +  text);
//         let newText = text.toUpperCase();
//         setText(newText)
//     }

//     const handleLoClick = ()=>{ 
//         let newText = text.toLowerCase();
//         setText(newText)
//     }

//     const handleClearClick = ()=>{ 
//         let newText = '';
//         setText(newText)
//     }

//     const handleOnChange = (event)=>{
//         // console.log("On change");
//         setText(event.target.value)
//     }

//     // Credits: A
//     const handleCopy = () => {
//         console.log("I am copy");
//         var text = document.getElementById("myBox");
//         text.select();
//         text.setSelectionRange(0, 9999);
//         navigator.clipboard.writeText(text.value);
//     }

//     // Credits: Coding Wala
//     const handleExtraSpaces = () => {
//         let newText = text.split(/[ ]+/);
//         setText(newText.join(" "))
//     }

//     const [text, setText] = useState(''); 
//     // text = "new text"; // Wrong way to change the state
//     // setText("new text"); // Correct way to change the state
//     return (
//         <>
//         <div className="container" style={{color: props.mode==='dark'?'white':'#042743'}}> 
//             <h1>{props.heading}</h1>
//             <div className="mb-3"> 
//             <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'grey':'white', color: props.mode==='dark'?'white':'#042743'}} id="myBox" rows="8"></textarea>
//             </div>
//             <button className="btn btn-primary mx-1" onClick={handleUpClick}>Convert to Uppercase</button>
//             <button className="btn btn-primary mx-1" onClick={handleLoClick}>Convert to Lowercase</button>
//             <button className="btn btn-primary mx-1" onClick={handleClearClick}>Clear Text</button>
//             <button className="btn btn-primary mx-1" onClick={handleCopy}>Copy Text</button>
//             <button className="btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
//         </div>
//         <div className="container my-3" style={{color: props.mode==='dark'?'white':'#042743'}}>
//             <h2>Your text summary</h2>
//             <p>{text.split(" ").length} words and {text.length} characters</p>
//             <p>{0.008 *  text.split(" ").length} Minutes read</p>
//             <h2>Preview</h2>
//             <p>{text.length>0?text:"Enter something in the textbox above to preview it here"}</p>
//         </div>
//         </>
//     )
// }





// import React, {useState} from 'react'


// export default function TextForm(props) {
//     const handleUpClick = ()=>{
//         // console.log("Uppercase was clicked: " +  text);
//         let newText = text.toUpperCase();
//         setText(newText)
//     }

//     const handleLoClick = ()=>{ 
//         let newText = text.toLowerCase();
//         setText(newText)
//     }

//     const handleClearClick = ()=>{ 
//         let newText = '';
//         setText(newText)
//     }

//     const handleOnChange = (event)=>{
//         // console.log("On change");
//         setText(event.target.value)
        
//     }

//     // Credits: A
//     const handleCopy = () => {
//         console.log("I am copy");
//         var text = document.getElementById("myBox");
//         text.select();
//         text.setSelectionRange(0, 9999);
//         navigator.clipboard.writeText(text.value);
//     }

//     // Credits: Coding Wala
//     const handleExtraSpaces = () => {
//         let newText = text.split(/[ ]+/);
//         setText(newText.join(" "))
//     }

//     const [text, setText] = useState(''); 
//     // text = "new text"; // Wrong way to change the state
//     // setText("new text"); // Correct way to change the state
//     return (
//         <>
//         <div className="container" style={{color: props.mode==='dark'?'white':'#042743'}}> 
//             <h1>{props.heading}</h1>
//             <div className="mb-3"> 
//             <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'grey':'white', color: props.mode==='dark'?'white':'#042743'}} id="myBox" rows="8"></textarea>
//             </div>
//             <button className="btn btn-primary mx-1" onClick={handleUpClick}>Convert to Uppercase</button>
//             <button className="btn btn-primary mx-1" onClick={handleLoClick}>Convert to Lowercase</button>
//             <button className="btn btn-primary mx-1" onClick={handleClearClick}>Clear Text</button>
//             <button className="btn btn-primary mx-1" onClick={handleCopy}>Copy Text</button>
//             <button className="btn btn-primary mx-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
//         </div>
//         <div className="container my-3" style={{color: props.mode==='dark'?'white':'#042743'}}>
//             <h2>Your text summary</h2>
//             <p>{text.split(" ").length} words and {text.length} characters</p>
//             <p>{0.008 *  text.split(" ").length} Minutes read</p>
//             <h2>Preview</h2>
//             <p>{text.length>0?text:"Enter something in the textbox above to preview it here"}</p>
//         </div>
//         </>
//     )
// }







































// import React,{useState} from 'react'


// export default function TextForm(props) {
//     const handleUpClick = ()=>{
//         console.log("uppercase wass clicked" + text);
//         let newText = text.toUpperCase();
//         setText(newText)
//     }

//     const handleLoClick = ()=>{
//         // console.log("uppercase wass clicked" + text);
//         let newText = text.toLowerCase();
//         setText(newText)
//     }

//     const handleClearClick = ()=>{
//         // console.log("uppercase wass clicked" + text);
//         let newText = '';
//         setText(newText)
//     }



//     const handleOnchange = (event)=>{
//         console.log("on change");
//         setText(event.target.value);
//     }

//     const handlecopy = () => {
//         console.log(" I am copy");
//         var text = document.getElementById("MyBox");
//         text.select();
//         navigator.clipboard.writeText(text.value);

//     }

//     const handleExtraspaces = ()=> {
//      let newText = text.split(/[ ]+/);
//      setText(newText.join(" "))
//     }









//     const [text, setText] = useState('');
//     return (
//         <>
//         <div>
//         <h1>{props.heading}</h1>
// <div className="mb-3">
// < <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'grey':'white', color: props.mode==='dark'?'white':'#042743'}} id="myBox" rows="8"></textarea>
//             </div>
// </div>
// <button className="btn btn-primary mx-2" onClick={handleUpClick}>convert to uppercase</button>
// <button className="btn btn-primary mx-2" onClick={handleLoClick}>convert to Lowercase</button>
// <button className="btn btn-primary mx-2" onClick={handleClearClick}>Clear text</button>
// <button className="btn btn-primary mx-2" onClick={handlecopy}>Copy text</button>
// <button className="btn btn-primary mx-2" onClick={handleExtraspaces}>remove Extra Spaces</button>
//     </div>
//     <div className="conatiner my -3">
//         <h1>your text summary</h1>
//         <p>{text.split(" ").length} words and  {text.length} characters </p>
//         <p>{0.008  *    text.split(" ").length} Minutes read</p>
//        <h3>preview</h3>
//        <p>{text}</p>
//     </div>
//     </>
//     )
// } 
